import React from "react";
import { HeartIcon } from "lucide-react";
import { Daisy } from "./decor/Daisy";
import { LeafSprig } from "./decor/LeafSprig";
import { lifestylePhotos } from "../data/offer";
export function ConnectionSection() {
  return <section className="bg-cream" data-id="element-44" data-mp="2tgjq98c47bix">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 md:py-24 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-45" data-mp="2tfifl4z0gr1q">
        <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-46" data-mp="2kg56idesu4hj">
          <img src={lifestylePhotos.readingTogether} alt="Une maman lit une histoire à sa fille, blotties sur le canapé" className="aspect-[4/5] w-full rounded-[2.5rem] border-[6px] border-tangerine object-cover" data-id="element-47" data-mp="2kj13nzitop4x" />
          <LeafSprig className="absolute -bottom-6 -left-5 w-20" data-id="element-48" data-mp="2fid60v039a1q" />
          <Daisy className="absolute -right-3 -top-3 w-11" data-id="element-49" data-mp="8qm4dk1yzemy" />
        </div>
        <div data-id="element-50" data-mp="dq70znto3awi">
          <h2 className="font-display text-[1.85rem] font-bold leading-[1.15] text-royal md:text-[2.5rem] md:leading-[1.1]" data-id="element-51" data-mp="dpynbtpq01k9">
            Vous aimeriez transmettre votre foi à vos enfants… mais vous ne savez pas
            toujours comment vous y prendre ?
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-cocoa md:text-lg" data-id="element-52" data-mp="7881sprxz31">
            <p data-id="element-53" data-mp="e2k0ftggjdgs">
              Entre l’école, les repas, les devoirs et le coucher, les journées passent vite.
              Et même lorsque l’on souhaite parler de Dieu à ses enfants, il n’est pas
              toujours facile de trouver les bons mots ou le bon moment.
            </p>
            <p data-id="element-54" data-mp="3dhfc5nsj0de7">
              Pourtant, ce sont parfois les instants les plus simples — une histoire lue
              ensemble, une question posée avec douceur, une petite prière — qui ouvrent les
              plus belles conversations.
            </p>
          </div>
          <div className="mt-8 flex gap-4 rounded-[1.75rem] bg-white px-6 py-5 ring-[3px] ring-rosy/30" data-id="element-55" data-mp="16o3fyn83ez1k">
            <HeartIcon className="mt-1 h-6 w-6 shrink-0 fill-rosy text-rosy" aria-hidden="true" data-id="element-56" data-mp="11p0cv8bob2w8" />
            <p className="font-display text-xl font-bold leading-snug text-royal-deep md:text-2xl" data-id="element-57" data-mp="3vgymzo9765g5">
              Vous n’avez pas besoin d’être théologien ni de préparer de longues leçons pour
              commencer.
            </p>
          </div>
        </div>
      </div>
    </section>;
}